import { NextLink } from 'components/src/link';
import * as React from 'react';
import { LargeAddOnFieldsFragment } from 'types/generated';
import ISKFormat from '../common/ISKFormat';
import { Heading, Paragraph } from 'components/src/typography';
import CardButton from '../Card/CardButton';
import { useSetAtom } from 'jotai';
import { addOnsQuantityAtom } from '../../store';

type Props = {
  data: LargeAddOnFieldsFragment;
};

const AddToPackageCard = ({ data }: Props) => {
  const setAddOnsQuantity = useSetAtom(addOnsQuantityAtom);

  // If there's no uri then we assume it's a button that adds to the package, and we display '+' as prefix
  const showPrefix = !Boolean(data.addButton?.uri);

  if (!data.price && !data.addButton && !data.moreInfoLink?.uri) return null;

  return (
    <div className="mt-32 flex flex-col items-center justify-between gap-32 rounded-28 bg-white-15 px-16 py-32 md:flex-row md:px-32 md:py-16">
      {data.moreInfoLink?.uri && data.moreInfoLink?.title && (
        <NextLink href={data.moreInfoLink?.uri} label={data.moreInfoLink?.title} bold size="large" />
      )}
      <div className="flex w-full flex-col items-center gap-16 md:w-auto md:flex-row">
        {data.price && (
          <div className="flex items-end">
            <ISKFormat
              value={data.price}
              showPrefix={showPrefix}
              renderText={(value) => (
                <Heading variant="xs" classes="!text-xl-fixed text-black-100">
                  {value}
                </Heading>
              )}
            />
            <Paragraph classes="ml-8 text-black-100">{'/mán'}</Paragraph>
          </div>
        )}
        {data.addButton && (
          <CardButton
            buttonData={data.addButton}
            autoWidth
            onClick={() => {
              if (data.id) {
                setAddOnsQuantity({ id: data.id, change: 1 });
              }
            }}
          />
        )}
      </div>
    </div>
  );
};

export default AddToPackageCard;
